export default __webpack_public_path__ + "static/media/dependants.3c125b9e.svg";